import { SPACE_RACE_TEAMS } from '@showbie-socrative/socrative-utils';

module.exports = Object.keys(SPACE_RACE_TEAMS).map((key) => {
  return SPACE_RACE_TEAMS[key];
});
